module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_straight_shadow.1edbe696.png";